export default __webpack_public_path__ + "static/media/getFetch.c5eaa527.cjs";